exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "  .modalPontoFisico .modal-content {\r\n    width: -webkit-max-content;\r\n    width: -moz-max-content;\r\n    width: max-content;\r\n  }\r\n\r\n  .editar {\r\n    color: blue;\r\n    font-size: 1.4em;\r\n  }\r\n\r\n  .editar:hover {\r\n    cursor: pointer;\r\n    color: black;\r\n  }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ponto-fisico/editar-ponto-fisico/editar-ponto-fisico.component.css
// module id = ../../../../../src/app/ponto-fisico/editar-ponto-fisico/editar-ponto-fisico.component.css
// module chunks = main